import { render, staticRenderFns } from "./view-record-detail.vue?vue&type=template&id=ac40b4ce"
import script from "./view-record-detail.vue?vue&type=script&lang=js"
export * from "./view-record-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports